<template>
  <div class="preformatted-text-view">{{value}}</div>
</template>

<script>
export default {
  name: 'PreformattedTextView',
  props: {
    value: {
      type: String,
    },
  },
};
</script>
<style scoped>
.preformatted-text-view{
  max-width: 50em;
  white-space: pre-line;
}
</style>
